import React, {useState} from "react";
import { defaultEmptyLogo } from "../../assets/images";

export function Image(props) {
    const {path, className = '', alt = ''} = props;
    const [brokenImage, setBrokenImage] = useState(false);

    const imageUrl = brokenImage ? defaultEmptyLogo : path;
    brokenImage &&  console.log(brokenImage);
    return <img src={imageUrl}
                className={className}
                alt={alt}
                onError={() => {
                    // console.log('broken')
                    setBrokenImage(true)
                }}/>
}
